import { InjectionKey, ComputedRef } from 'vue';

export interface OrganizationInjection {
  organizationId: ComputedRef<number>
}

export const OrganizationInjectionKey = Symbol('Organization information') as InjectionKey<OrganizationInjection>;
